export default __webpack_public_path__ + "static/media/Calibre-Medium.eeabbc40.woff";